import { svgRectToOverlayPct } from './modifierOverlayCoords';

const YETTI_PLAY_STRIP_OFFSET_Y = 719.059;
const YETTI_PLAY_STRIP_HEIGHT = 929.588;

function yettiLocalY(absoluteSvgY: number): number {
  return absoluteSvgY - YETTI_PLAY_STRIP_OFFSET_Y;
}

export type YettiIceOverlayPath = {
  id: string;
  srcKey: 'yetti_up' | 'yetti_bottom';
  startXPct: number;
  startYPct: number;
  finishXPct: number;
  finishYPct: number;
  widthPct: number;
  heightPct: number;
};

function icePath(
  id: string,
  srcKey: YettiIceOverlayPath['srcKey'],
  startSvgX: number,
  startSvgY: number,
  finishSvgX: number,
  finishSvgY: number,
  widthSvg: number,
  heightSvg: number,
): YettiIceOverlayPath {
  const start = svgRectToOverlayPct(
    startSvgX,
    yettiLocalY(startSvgY),
    widthSvg,
    heightSvg,
    YETTI_PLAY_STRIP_HEIGHT,
  );
  const finish = svgRectToOverlayPct(
    finishSvgX,
    yettiLocalY(finishSvgY),
    widthSvg,
    heightSvg,
    YETTI_PLAY_STRIP_HEIGHT,
  );
  return {
    id,
    srcKey,
    startXPct: start.xPct,
    startYPct: start.yPct,
    finishXPct: finish.xPct,
    finishYPct: finish.yPct,
    widthPct: start.widthPct,
    heightPct: start.heightPct,
  };
}

export const YETTI_ICE_OVERLAY_PATHS: readonly YettiIceOverlayPath[] = [
  icePath(
    'yetti_up',
    'yetti_up',
    6835.08,
    224.38,
    6821.82,
    848.38,
    2237.34,
    448.75,
  ),
  icePath(
    'yetti_bottom',
    'yetti_bottom',
    6793.33,
    1962.17,
    6793.33,
    1545.83,
    2283.84,
    518.35,
  ),
] as const;
